import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CourseFilterComponent } from '../course-filter/course-filter.component';
import { IconComponent } from '../icon/icon.component';
import { Category } from '../../models/interfaces/category.interface';
import { CourseFilters } from '../../models/interfaces/course-filters.interface';
import { CourseType } from '../../models/enums/course-type.enum';
import { CourseLocation } from '../../models/enums/course-location.enum';
import { COURSE_TYPE_LABELS } from '../../models/records/course-type.record';
import { COURSE_LOCATION_LABELS } from '../../models/records/course-location.record';
import { UserCoursesFilter } from '../../models/interfaces/my-courses-filter.interface';

@Component({
  selector: 'l-course-list-filter, l-home-filter, l-user-courses-filter',
  standalone: true,
  imports: [FormsModule, CourseFilterComponent, IconComponent],
  templateUrl: './course-list-filter.component.html',
})
export class CourseListFilterComponent {
  @Input()
  public categories: Category[] = [];

  @Input()
  public searchInputId = 'course-list-search';

  @Input()
  public searchInputName = 'courseListSearch';

  @Input()
  public showFacetChips = true;

  @Output()
  public selectedCategoriesChange: EventEmitter<Category[]> = new EventEmitter<Category[]>();

  @Output()
  public searchTermChange: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  public filtersChange: EventEmitter<UserCoursesFilter> = new EventEmitter<UserCoursesFilter>();

  public selectedCategories: Category[] = [];
  public selectedType: CourseType | null = null;
  public selectedLocation: CourseLocation | null = null;
  public searchTerm = '';

  public onFiltersApplied(filters: CourseFilters): void {
    this.selectedCategories = filters.categories ?? [];
    this.selectedType = filters.type;
    this.selectedLocation = filters.location;
    this.emitChanges();
  }

  /** @deprecated Prefer onFiltersApplied — kept for courses page template compatibility. */
  public onCategoriesFilter(filters: CourseFilters): void {
    this.onFiltersApplied(filters);
  }

  public onSearchTermChange(term: string): void {
    this.searchTerm = term;
    this.emitChanges();
  }

  public removeCategory(category: Category): void {
    this.selectedCategories = this.selectedCategories.filter(item => item.id !== category.id);
    this.emitChanges();
  }

  public removeType(): void {
    this.selectedType = null;
    this.emitChanges();
  }

  public removeLocation(): void {
    this.selectedLocation = null;
    this.emitChanges();
  }

  public getTypeLabel(type: CourseType): string {
    return COURSE_TYPE_LABELS[type] || type;
  }

  public getLocationLabel(location: CourseLocation): string {
    return COURSE_LOCATION_LABELS[location] || location;
  }

  private emitChanges(): void {
    this.selectedCategoriesChange.emit(this.selectedCategories);
    this.searchTermChange.emit(this.searchTerm);
    this.filtersChange.emit({
      categories: this.selectedCategories,
      type: this.selectedType,
      location: this.selectedLocation,
      searchTerm: this.searchTerm,
    });
  }
}
